import { Button, Dialog } from '@/components/UI'
import { useState } from 'react'

type SpotItem = {
  id: number
  name: string
  address?: string | null
}

type Props = {
  opened: boolean
  onClose: () => void
  spots?: SpotItem[]
  onSelect?: (spotId: number) => void
}

/**
 * スポット選択ダイアログ（クーポン店員消込用）。
 * Figma: node 561-22252
 */
export function DialogV2SpotSelect({ opened, onClose, spots = [], onSelect }: Props) {
  const [selectedSpotId, setSelectedSpotId] = useState<number | null>(null)

  const handleClose = () => {
    setSelectedSpotId(null)
    onClose()
  }

  const handleConfirm = () => {
    if (selectedSpotId == null) return
    const id = selectedSpotId
    setSelectedSpotId(null)
    onSelect?.(id)
    // onClose() は呼ばない: onSelect で COUPON_SPOT_SELECTED が送信されてステートが変わると
    // opened が false になり自然に閉じる。ここで onClose() を呼ぶと DIALOG_CLOSED が
    // 遷移後の couponUse 状態に届いて idle に戻ってしまう。
  }

  return (
    <Dialog selectorState={opened} closeFunc={handleClose} title="スポット選択">
      <div className="p-4 flex flex-col gap-4">
        <p className="text-center text-[12px] text-black leading-[16px]">
          クーポンを使用する
          <br />
          スポットを選択してください
        </p>
        <select
          aria-label="使用するスポットを選択してください"
          className="w-full border border-black rounded-[8px] px-[10px] py-[10px] text-base text-black"
          value={selectedSpotId ?? ''}
          onChange={(e) => setSelectedSpotId(e.target.value !== '' ? Number(e.target.value) : null)}
        >
          <option value="">選択してください</option>
          {spots.map((spot) => (
            <option key={spot.id} value={spot.id}>
              {spot.name}
            </option>
          ))}
        </select>
        <div className="flex gap-2 justify-center">
          <button
            type="button"
            className="h-[48px] w-[123px] rounded-[32px] bg-[#eeeeee] text-[#757575] font-bold text-[15px]"
            onClick={handleClose}
          >
            閉じる
          </button>
          <Button
            label="選択"
            variant="primary"
            size="md"
            round
            disabled={selectedSpotId == null}
            onClick={handleConfirm}
            className="w-[123px]"
          />
        </div>
      </div>
    </Dialog>
  )
}
